import { ContactsMobileListItem, type ContactsMobileListItemProps } from "@/common";
import { SwipeToDelete } from "@/shared/Components";
import type { FC } from "react";

type Props = {
  onClickEdit?: () => void;
  onClickDelete?: () => void;
  connectedAs?: string;
  additionalInfo?: string;
} & Omit<ContactsMobileListItemProps, "onClick">;

export const MobileRecord: FC<Props> = ({ onClickDelete = () => "", onClickEdit, ...props }) => {
  return (
    <SwipeToDelete onClickEdit={onClickEdit} onDelete={onClickDelete}>
      <ContactsMobileListItem {...props} />
    </SwipeToDelete>
  );
};
